import moment from 'moment';
import React from 'react';
import { DataFileEntity } from 'v2/DataFiles/models';

export function formatTextNewlines(text: string) {
  return text.split('\n').map((line: string, i: number, arr: string[]) => {
    const lineHtml = <span key={i}>{line}</span>;

    if (i === arr.length - 1) {
      return lineHtml;
    } else {
      return [lineHtml, <br key={i + 'br'} />];
    }
  });
}

export function formatDataFileType(type: DataFileEntity['file_type']) {
  if (type) {
    return type.replace(/_/g, ' ');
  }
  return '';
}

export function formatDateLong(date: string) {
  return moment(date).format(moment.localeData().longDateFormat('L'));
}
